"use strict";

export function initInScope ($scope) {
    let form = $scope.find('.js-parsley'),
         includedSubmit = $scope.find('#js-parsley__included-submit'),
         excludedSubmit = $scope.find('#js-parsley__excluded-submit'),
        //  example: <input class="js-parsley-input-excluded-toggle" type="text" name="name" data-parsley-excluded="true" required>
         toggleInput = $scope.find('.js-parsley-input-excluded-toggle');

    includedSubmit.on('click', function (e) {
        toggleInput.removeAttr('data-parsley-excluded');
        toggleInput.parsley().validate();
    });
    excludedSubmit.on('click', function (e) {
        toggleInput.attr('data-parsley-excluded', 'true');
    });
};